// removed by extract-text-webpack-plugin
module.exports = {"inputIconButtons":"Common-inputIconButtons","settingValue":"Common-settingValue","fieldRow":"Common-fieldRow"};